import { render } from "./approvalConsole.vue?vue&type=template&id=df40e120"
import script from "./approvalConsole.vue?vue&type=script&lang=js"
export * from "./approvalConsole.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__